import React from 'react';
import styles from '../DataTablePanel/styles.css';
import GroupHighlightSelectField from '../GroupHighlightSelectField/index.jsx';
import { useTranslation } from 'react-i18next';

// Highlighter icon (Material Symbols format_ink_highlighter)
const HighlighterIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#1f1f1f">
		<path d="M80 0v-160h800V0H80Zm504-480L480-584 320-424l103 104 161-160Zm-47-160 103 103 160-159-104-104-159 160Zm-84-29 216 216-189 190q-24 24-56.5 24T367-263l-27 23H140l126-125q-24-24-25-57.5t23-57.5l189-189Zm0 0 187-187q24-24 56.5-24t56.5 24l104 103q24 24 24 56.5T857-640L669-453 453-669Z" />
	</svg>
);

export default function GroupHighlightsPanel({ groupHighlights }) {
	const { t } = useTranslation();
	return (
		<>
			{groupHighlights && groupHighlights.options.length ? (
				<div className="idp-settings-advanced advanced-settings">
					<div className="idp-settings-advanced__col">
						<div className="idp-settings-advanced__section-title">
							<HighlighterIcon />
							<span className="idp-settings-advanced__heading">{t('Chart highlighting:')}</span>
						</div>
						<GroupHighlightSelectField
							groupHighlights={groupHighlights}
							containerClassName={styles.advancedSelectField}
							selectClassName={styles.advancedSelect}
						/>
					</div>
				</div>
			) : null}
		</>
	);
}
